import React, { useEffect, useState } from 'react';
import { teacherApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaSave } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Marks() {
  const [grades,      setGrades]      = useState([]);
  const [subjects,    setSubjects]    = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [gradeId,     setGradeId]     = useState('');
  const [assId,       setAssId]       = useState('');
  const [marksData,   setMarksData]   = useState({ learners:[], marks:{} });
  const [loading,     setLoading]     = useState(false);
  const [modal,       setModal]       = useState(false);
  const [scores,      setScores]      = useState({});
  const [form,        setForm]        = useState({ name:'', subject_id:'', grade_id:'', total_marks:'', type:'test' });

  useEffect(() => {
    Promise.all([teacherApi.getGrades(), teacherApi.getSubjects()])
      .then(([g, s]) => { setGrades(g.data.data); setSubjects(s.data.data); });
  }, []);

  useEffect(() => {
    if (!gradeId) return;
    teacherApi.getAssessments({ grade_id: gradeId })
      .then(r => setAssessments(r.data.data));
  }, [gradeId]);

  useEffect(() => {
    if (!assId) return;
    setLoading(true);
    teacherApi.getMarks({ assessment_id: assId })
      .then(r => {
        setMarksData(r.data.data);
        const init = {};
        r.data.data.learners.forEach(l => {
          const m = r.data.data.marks[l.user_id];
          init[l.user_id] = { score: m?.score ?? '', comment: m?.comment ?? '' };
        });
        setScores(init);
      }).finally(() => setLoading(false));
  }, [assId]);

  const handleSave = async () => {
    const marks = Object.entries(scores).map(([lid, v]) => ({
      learner_id: parseInt(lid), score: v.score === '' ? null : parseFloat(v.score), comment: v.comment,
    }));
    try {
      await teacherApi.saveMarks({ assessment_id: parseInt(assId), marks });
      toast.success('Marks saved successfully');
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const addAssessment = async (e) => {
    e.preventDefault();
    try {
      const res = await teacherApi.addAssessment({ ...form, grade_id: gradeId });
      toast.success('Assessment created');
      setModal(false);
      const assRes = await teacherApi.getAssessments({ grade_id: gradeId });
      setAssessments(assRes.data.data);
      setAssId(String(res.data.data.assessment_id));
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const selectedAss = assessments.find(a => String(a.assessment_id) === assId);

  return (
    <div>
      <div className="page-header"><h2>Marks & Assessments</h2></div>

      <div style={{ display:'flex', gap:12, marginBottom:20, flexWrap:'wrap', alignItems:'flex-end' }}>
        <div>
          <label className="sms-label">Grade</label>
          <select className="sms-input" style={{ width:180 }} value={gradeId} onChange={e=>{setGradeId(e.target.value);setAssId('');}}>
            <option value="">Select Grade</option>
            {grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
          </select>
        </div>
        <div>
          <label className="sms-label">Assessment</label>
          <select className="sms-input" style={{ width:220 }} value={assId} onChange={e=>setAssId(e.target.value)} disabled={!gradeId}>
            <option value="">Select Assessment</option>
            {assessments.map(a=><option key={a.assessment_id} value={a.assessment_id}>{a.assessment_name || a.name} ({a.subject_name})</option>)}
          </select>
        </div>
        {gradeId && <button className="sms-btn sms-btn-outline" onClick={()=>{ setForm({name:'',subject_id:'',grade_id:gradeId,total_marks:'',type:'test'}); setModal(true); }}><FaPlus size={12}/> New Assessment</button>}
      </div>

      {!gradeId && <div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'60px 0'}}>Select a grade to get started</div>}
      {gradeId && !assId && assessments.length===0 && <div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'40px 0'}}>No assessments yet — create one first</div>}
      {gradeId && assId && loading && <Spinner />}

      {gradeId && assId && !loading && marksData.learners.length > 0 && (
        <div className="sms-card" style={{ padding:0, overflow:'hidden' }}>
          <div style={{ padding:'16px 20px', borderBottom:'1px solid #e5e7eb', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div>
              <span style={{ fontWeight:600 }}>{selectedAss?.name}</span>
              <span style={{ marginLeft:12, color:'#6b7280', fontSize:'0.85rem' }}>Total: {selectedAss?.total_marks} marks</span>
            </div>
            <button className="sms-btn sms-btn-primary sms-btn-sm" onClick={handleSave}><FaSave size={12}/> Save All</button>
          </div>
          <table className="sms-table">
            <thead><tr><th>Learner</th><th>Score / {selectedAss?.total_marks}</th><th>%</th><th>Comment</th></tr></thead>
            <tbody>
              {marksData.learners.map(l => {
                const sc = scores[l.user_id] || { score:'', comment:'' };
                const pct = sc.score !== '' && selectedAss?.total_marks ? Math.round((sc.score/selectedAss.total_marks)*100) : null;
                return (
                  <tr key={l.user_id}>
                    <td style={{ fontWeight:500 }}>{l.first_name} {l.surname}</td>
                    <td>
                      <input type="number" className="sms-input" style={{ width:90 }} min={0} max={selectedAss?.total_marks}
                        value={sc.score} onChange={e=>setScores(s=>({...s,[l.user_id]:{...sc,score:e.target.value}}))} />
                    </td>
                    <td style={{ fontWeight:600, color:pct!==null?(pct>=75?'#10b981':pct>=50?'#f59e0b':'#ef4444'):'#9ca3af' }}>
                      {pct !== null ? `${pct}%` : '—'}
                    </td>
                    <td>
                      <input type="text" className="sms-input" placeholder="Optional comment"
                        value={sc.comment} onChange={e=>setScores(s=>({...s,[l.user_id]:{...sc,comment:e.target.value}}))} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={modal} onClose={()=>setModal(false)} title="Create Assessment">
        <form onSubmit={addAssessment}>
          <div style={{marginBottom:14}}><label className="sms-label">Assessment Name <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required /></div>
          <div style={{marginBottom:14}}><label className="sms-label">Subject <span style={{color:'#ef4444'}}>*</span></label>
            <select className="sms-input" value={form.subject_id} onChange={e=>setForm({...form,subject_id:e.target.value})} required>
              <option value="">Select Subject</option>
              {subjects.filter(s=>String(s.grade_id)===gradeId).map(s=><option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>)}
            </select>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div><label className="sms-label">Total Marks <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" type="number" value={form.total_marks} onChange={e=>setForm({...form,total_marks:e.target.value})} required min={1} /></div>
            <div><label className="sms-label">Type</label>
              <select className="sms-input" value={form.type} onChange={e=>setForm({...form,type:e.target.value})}>
                {['test','exam','assignment','project','practical'].map(t=><option key={t} value={t} style={{textTransform:'capitalize'}}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:10}}>
            <button type="submit" className="sms-btn sms-btn-primary">Create</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
